<template>
	<div class="cog-stripe-card-placeholder cog-field">
		<div v-if="mobile" class="cog-stripe-card-placeholder__payment-type cog-row ">
			<div class="cog-field__placeholder cog-input cog-input--tiny">
				<div class="cog-field__placeholder-inner">&nbsp;</div>
			</div>
			<div class="cog-field__placeholder cog-input cog-input--tiny">
				<div class="cog-field__placeholder-inner">&nbsp;</div>
			</div>
		</div>
		<div class="cog-field__placeholder cog-input">
			<div class="cog-field__placeholder-inner">&nbsp;</div>
		</div>
		<div class="cog-row">
			<div class="cog-field__placeholder cog-input cog-input--long">
				<div class="cog-field__placeholder-inner">&nbsp;</div>
			</div>
			<div class="cog-field__placeholder cog-input cog-input--long">
				<div class="cog-field__placeholder-inner">&nbsp;</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'CStripeCardPlaceholder',
		props: {
			mobile: { type: Boolean, default: null }
		}
	};
</script>
<style lang="scss">
	.cog-stripe-card-placeholder {
		margin-bottom: calc(var(--gutter) / 4);
	}

	.cog-stripe-card-placeholder__payment-type .cog-field__placeholder-inner {
		min-height: 55px;
	}
</style>
